<script>
    import { onDestroy, getContext } from 'svelte'
    import { navigate } from 'svelte-routing'
    import { Spinner, Table, Container, Row, Col, Button,
      Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap'
    import date from 'date-and-time'
    import { FirebaseResults } from '../../middleware/database'
    import { Tasks } from '../../middleware/database/tasks'
    import { currentUser } from '../../stores/current_user'
    import projects from '../../stores/projects'

    let tasks = []
    let filteredTasks = []
    let unsubscribeQuery = null
    let loading = false
    let showPage = false
    let isOpen = false
    let projectName = 'All projects'
    let currentProject = null
    let pageSize = 50
    let page = 1
    let haveNextPage = false
    let havePreviousPage = false

    $: if (!$currentUser) {
        loading = false
        showPage = false
    } else {
        loading = true
        showPage = true
    }

    $: haveNextPage = filteredTasks.length === pageSize
    $: havePreviousPage = page > 1
  

    $: if (loading) {
        //fetchTasks(add filters)
        const query = Tasks.findAll({projectId: currentProject}).limit(pageSize)
        page = 1
        fetchTasks(query)
    }

    const fetchTasks = (query) => {
        if (unsubscribeQuery)
            unsubscribeQuery()

        unsubscribeQuery = query.onSnapshot(docs => {
            tasks = FirebaseResults.map(docs)
            filteredTasks = [...tasks]
            
        }, err => {
            
            console.log(`Encountered error: ${err}`)
        })
        loading = false

    }

    onDestroy(() => {
        if (unsubscribeQuery)
          unsubscribeQuery()
    })

    const projectFilter = (projectId) => {
      currentProject = projectId
      if (projectId) {
        const query = Tasks.findAll({projectId: currentProject}).limit(pageSize)
        page = 1
        fetchTasks(query)
      }
    }

    function nextPage() {
        if (filteredTasks.length > 0) {
            const last = filteredTasks[filteredTasks.length - 1].title
            const createdAt = filteredTasks[filteredTasks.length - 1].createdAt
            page += 1
            const query = Tasks.findAll({projectId: currentProject}).startAfter(last,createdAt).limit(pageSize)
            fetchTasks(query)
        }
    }

    function previousPage() {
        if (filteredTasks.length > 0) {
            const first = filteredTasks[0].title
            const createdAt = filteredTasks[0].createdAt
            page -= 1
            const query = Tasks.findAll({projectId: currentProject}).endBefore(first, createdAt).limitToLast(pageSize)
            fetchTasks(query)
        }
    }

</script>

<style>
  .header {
    background-color: #fff;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    flex-direction: row;
  }
</style>

{#if showPage}
<Container class="mt-5">
  <Row>
    <Col>
      <div class="header">
        <h4 style="margin-right: auto;">Tasks</h4>
        <Dropdown {isOpen} toggle={() => (isOpen = !isOpen)}>
          <DropdownToggle caret>{projectName}</DropdownToggle>
          <DropdownMenu>
            <DropdownItem on:click={() => projectFilter(null)}>All projects</DropdownItem>
            <DropdownItem divider />
            {#each Object.keys($projects) as projectKey}
              <DropdownItem on:click={() => projectFilter(projectKey)}>{$projects[projectKey].name}</DropdownItem>
            {/each}
          </DropdownMenu>
        </Dropdown>
        <Button class="float-right" style="margin-left: 10px" color="primary" onclick={() => navigate("/tasks/create")} disabled={!$currentUser.isAdmin}>Create new task</Button>
      </div>
    </Col>
  </Row>
  <Row>
    <Col>
        {#if loading}
          <Spinner size="lg" color="dark" type="grow" />
        {:else}
          <Table hover class="bg-white">
            <thead>
              <tr>
                  <th>Title</th>
                  <th>State</th>
                  <th>Expirer</th>
                  <th>Project</th>
                  <th>#Sub tasks</th>
              </tr>
            </thead>
            <tbody>
              {#each filteredTasks as task (task.id)}
              <tr on:click={() => navigate(`/tasks/show/${task.id}`)} style="cursor: pointer">
                  <td>{task.title}</td>
                  <td>{task.state}</td>
                  <td>{(task.expire) ? date.format(new Date(task.expire.seconds * 1000), 'DD/MM/YYYY') : ''}</td>
                  <td>{(task.projectId) ? $projects[task.projectId].name : '--No-Project--'}</td>
                  <td>{(task.subtasks) ? task.subtasks.length : 0}</td>
              </tr>
              {/each}
              <tr>
                <td colspan="5">
                  <Button on:click={previousPage} disabled={!havePreviousPage} color="primary">Prev</Button>
                  <Button on:click={nextPage} class="mr-3" disabled={!haveNextPage} color="primary">Next</Button>
                </td>
              </tr>
            </tbody>
          </Table>
        {/if}

        <!--/Card-->
    </Col>
  </Row>
</Container>
{/if}